import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card } from "@/components/ui/card";
import { toast } from "sonner";
import { Mail, ArrowLeft } from "lucide-react";
import Logo from "@/components/Logo";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
      toast.success("If an account exists, a reset link is on its way.");
    } catch {
      setSent(true); // never leak enumeration
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6" data-testid="forgot-page">
      <Card className="w-full max-w-md p-8 border-slate-200 shadow-none">
        <div className="mb-6"><Logo size="md" /></div>
        <Link to="/login" className="text-xs text-slate-500 font-mono-plex inline-flex items-center gap-1 mb-4"><ArrowLeft className="w-3 h-3" /> Back to sign in</Link>
        <div className="mb-6">
          <div className="text-xs font-mono-plex uppercase tracking-widest text-slate-500 mb-2">Password reset</div>
          <h2 className="font-heading text-3xl font-bold">Forgot your password?</h2>
          <p className="text-sm text-slate-500 mt-2">We'll email you a secure reset link. It expires in 30 minutes.</p>
        </div>
        {sent ? (
          <div className="rounded-md border border-emerald-200 bg-emerald-50 p-4 text-sm text-emerald-800" data-testid="forgot-sent">
            <div className="flex items-center gap-2 font-medium"><Mail className="w-4 h-4" /> Check your inbox</div>
            <p className="mt-2">If an account matches that email, a reset link is on its way.</p>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label htmlFor="email">Email</Label>
              <Input id="email" data-testid="forgot-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5" />
            </div>
            <Button type="submit" disabled={busy} data-testid="forgot-submit" className="w-full bg-slate-900 hover:bg-slate-800">
              {busy ? "Sending…" : "Send reset link"}
            </Button>
          </form>
        )}
      </Card>
    </div>
  );
}
